// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"655":"4d409291","924":"21b6299e"}[chunkId] + ".chunk.css";
};